import { memo } from "react";
import { Modal } from "ui/components/Modal";
import ModalHeader from "ui/components/Modal/ModalHeader";
import ModalBody from "ui/components/Modal/ModalBody";
import ModalFooter from "ui/components/Modal/ModalFooter";
import { ZPosition } from "ui/components/Modal/types";
import { TextField } from "ui/components/TextField/TextField";
import { Button } from "ui/components/Button/Button";
import { useHandleTextFieldChange } from "services/forms/hooks";
import { useTranslate } from "helpers";
import { CalculationSaveModalProps } from "./types";

const CalculationSaveModal: React.FC<CalculationSaveModalProps> = (props) => {
  const { show, onClose, formValues, setFormValues, errors, onSave, isLoading } =
    props;

  const { t } = useTranslate();

  const handleTextFieldChange = useHandleTextFieldChange(
    setFormValues,
    formValues
  );

  return (
    <Modal
      show={show}
      onHide={onClose}
      size="small"
      position="centered"
      zPosition={ZPosition.Top}
    >
      <ModalHeader title="admin.calculation.save.modal.title" onHide={onClose} />
      <ModalBody>
        <div className="px-4 py-4">
          <TextField
            type="text"
            name="name"
            label={t("admin.calculation.detail.name")}
            placeholder={t("admin.calculation.detail.name.placeholder")}
            onChange={handleTextFieldChange}
            value={formValues.name ?? ""}
            error={errors.name}
            required
          ></TextField>
        </div>
      </ModalBody>
      <ModalFooter>
        <div className="flex justify-end px-4 py-3">
          {isLoading ? (
            <Button loading={true} />
          ) : (
            <Button variant="primary" onClick={onSave}>
              {t("admin.save")}
            </Button>
          )}
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default memo(CalculationSaveModal);
